import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom'; 
import "./styles.css";

import { auth } from '../../Components/AppointmentComp/firebase'; 
import { FaUserCircle, FaCaretDown, FaBars, FaTimes } from 'react-icons/fa'; 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; 
import { faUser, faFile, faSignOutAlt } from '@fortawesome/free-solid-svg-icons'; 


export const NavComp = ({products}) => {

  const [isNavbarOpen, setIsNavbarOpen] = useState(false);

  const handleNavLinkClick = () => {
    setIsNavbarOpen(false); // Collapse navbar on link click
  };


   const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setIsLoggedIn(!!user);
    });
    return () => unsubscribe();
  }, []);

  const handleLogout = async () => {
    try {
      await auth.signOut();
      setIsLoggedIn(false);
      navigate('/');
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  const handleDropdownClick = (event) => {
    if (dropdownRef.current && dropdownRef.current.contains(event.target)) {
      setShowDropdown(false);
    }
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };



  const navRef = useRef(null);

  // Function to close the navbar
function closeNavbar() {
  const navbar = document.getElementById("navbar");
  if (navbar) {
    navbar.classList.remove("open");
  }
}











 



  
  return (

<nav
className="navbar navbar-expand-lg navbar-dark sticky-top"
style={{ backgroundColor: "rgb(43, 43, 43)" }}
>
<div className="container-fluid">
  <Link className="navbar-brand" to="/">
    <img src="/white optical logo.png" alt="Brand Logo" height="65" className="navbar-logo" />
  </Link>

  {/* Navbar Toggle Button */}
  <button
    className="navbar-toggler mobile-toggle-button"
    type="button"
    onClick={() => setIsNavbarOpen(!isNavbarOpen)}
    style={{
      position: "absolute",
      top: "10px",
      right: "10px",
      width: "40px",
      height: "40px",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <span className="navbar-toggler-icon"></span>
  </button>

  {/* Navbar Links */}
  <div className={`collapse navbar-collapse ${isNavbarOpen ? "show" : ""}`} id="navbarNav">
    <ul className="navbar-nav ms-auto">
      <li className="nav-item mx-3">
        <Link to="/" className="nav-link" onClick={handleNavLinkClick}>
          Home
        </Link>
      </li>

      <li className="nav-item mx-3 dropdown">
        <Link
          className="nav-link dropdown-toggle"
          to="#"
          id="aboutUsDropdown"
          role="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          Products
        </Link>
        <ul className="dropdown-menu" aria-labelledby="aboutUsDropdown">
          <li>
            <Link to="/sunglasses" className="dropdown-item" onClick={handleNavLinkClick}>
              Sunglasses
            </Link>
          </li>
          <li>
            <Link to="/spectacles" className="dropdown-item" onClick={handleNavLinkClick}>
              Spectacles
            </Link>
          </li>
          <li>
            <Link to="/contactlens" className="dropdown-item" onClick={handleNavLinkClick}>
              Contact Lenses
            </Link>
          </li>
          <li>
            <Link to="/lens" className="dropdown-item" onClick={handleNavLinkClick}>
              Lenses
            </Link>
          </li>
          <li>
            <Link to="/prostheticeye" className="dropdown-item" onClick={handleNavLinkClick}>
              Prosthetic Eye
            </Link>
          </li>
        </ul>
      </li>


                   <li className="nav-item mx-3 dropdown">
                    <Link className="nav-link dropdown-toggle" to="#" id="ourCoursesDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                      Services
                    </Link>
                    <ul className="dropdown-menu" aria-labelledby="ourCoursesDropdown">
                      <li><Link to="/lowvision" className="dropdown-item" onClick={handleNavLinkClick}>Low Vision</Link></li>
                      <li><Link to="/eyeinvestigation" className="dropdown-item" onClick={handleNavLinkClick}>Eye Investigation</Link></li>
                      <li><Link to="/eyeclinic" className="dropdown-item" onClick={handleNavLinkClick}>Eye Clinic</Link></li>
                      <li><Link to="/eyetherapeutic" className="dropdown-item" onClick={handleNavLinkClick}>Eye Therapeutic</Link></li>
                      <li><Link to="/orthopticassessment" className="dropdown-item" onClick={handleNavLinkClick}>Orthoptic Assessment</Link></li>
                      <li><Link to="/homeservice" className="dropdown-item" onClick={handleNavLinkClick}>Home Service</Link></li>
                      <li><Link to="/coporateprogram" className="dropdown-item" onClick={handleNavLinkClick}>Corporate Program</Link></li>
                      <li>
                          <a
                            href="https://www.echannelling.com/doctor-search?hospital_code=H629&hospital_name=Eye%20Care%20Institute%20Pvt%20Ltd-Colombo%208&isSpec=true"
                            className="dropdown-item"
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={handleNavLinkClick}
                          >
                            E-Channeling
                          </a>
                        </li>

                    </ul>
                  </li>



      <li className="nav-item mx-3">
        <Link to="/accessories" className="nav-link" onClick={handleNavLinkClick}>
          Accessories
        </Link>
      </li>
      <li className="nav-item mx-3">
        <Link to="/csr" className="nav-link" onClick={handleNavLinkClick}>
          CSR
        </Link>
      </li>
      <li className="nav-item mx-3">
        <Link to="/newsandevent" className="nav-link" onClick={handleNavLinkClick}>
          News & Events
        </Link>
      </li>

      <li className="nav-item mx-3">
        <Link to="/contactus" className="nav-link" onClick={handleNavLinkClick}>
          Contact Us
        </Link>
      </li>

      <li className="nav-item mx-3">
        <Link to="/cart" className="nav-link" onClick={handleNavLinkClick}>
          <i className="fas fa-shopping-cart"></i> Cart
        </Link>
      </li>

                    {/* Add Sign In and Sign Up buttons inside the toggle menu */}
        {!isLoggedIn && (
          <li className="auth-buttons">
            <Link to="/signin">
              <button className="navbar-btn-login" onClick={closeNavbar}>SIGN IN</button>
            </Link>
            {/* <Link to="/signup">
              <button className="navbar-btn-login" onClick={closeNavbar}>SIGN UP</button>
            </Link> */}
          </li>
        )}

          </ul>




       <div className="navbar-buttons">
        {isLoggedIn ? (
          <>
    
            <div className="user-menu-container">
              <button className="user-icon" onClick={toggleDropdown}>
                <FaUserCircle size={24} /> <FaCaretDown size={16} />
              </button>
              {showDropdown && (
                <ul className="user-dropdown" ref={dropdownRef}>
                  {/* <li>
                    <Link to="/userprofile" onClick={handleDropdownClick}>
                      <FontAwesomeIcon icon={faUser} className="me-2" /> My Profile
                    </Link>
                  </li>
                  <li>
                    <Link to="/viewapplication" onClick={handleDropdownClick}>
                      <FontAwesomeIcon icon={faFile} className="me-2" /> View My All Payments 
                    </Link>
                  </li>

                  <li>
                    <Link to="/viewpayment" onClick={handleDropdownClick}>
                      <FontAwesomeIcon icon={faFile} className="me-2" /> Download My Payment Slips
                    </Link>
                  </li>
 */}

                  <li>
                    <button onClick={(e) => { handleLogout(); handleDropdownClick(e); }}>
                      <FontAwesomeIcon icon={faSignOutAlt} className="me-2" /> Log Out
                    </button>
                  </li>

                </ul>
              )}
            </div>
          </>
        ) : (
          <></>
        )}
       </div>


    
  </div>
</div>
</nav>


  );
};
